import(/* webpackMode: "eager" */ "/frontend/node_modules/.pnpm/react-perfect-scrollbar@1.5.8_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-perfect-scrollbar/dist/css/styles.css");
;
import(/* webpackMode: "eager" */ "/frontend/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/frontend/src/assets/iconify-icons/generated-icons.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/frontend/src/components/LangRedirect.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/frontend/src/components/PrefetchStaticPaths.tsx");
